import { render, staticRenderFns } from "./CheckOutSucceeded.vue?vue&type=template&id=28d42806&scoped=true&"
import script from "./CheckOutSucceeded.vue?vue&type=script&lang=js&"
export * from "./CheckOutSucceeded.vue?vue&type=script&lang=js&"
import style0 from "./CheckOutSucceeded.vue?vue&type=style&index=0&id=28d42806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d42806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VImg,VSimpleTable})
